/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ServerVariable = {
  /**
   * Description of the server variable
   */
  description: string;
  /**
   * The environment variables
   */
  envVariables: Array<string>;
};

/** @internal */
export const ServerVariable$inboundSchema: z.ZodMiniType<
  ServerVariable,
  unknown
> = z.pipe(
  z.object({
    description: z.string(),
    env_variables: z.array(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "env_variables": "envVariables",
    });
  }),
);

export function serverVariableFromJSON(
  jsonString: string,
): SafeParseResult<ServerVariable, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ServerVariable$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ServerVariable' from JSON`,
  );
}
